const MenuNavMobile = {
  state: {
    mobileNav: false,
  },
  mutations: {
    'MENU_NAV_MOBILE/OPEN_NAV': function(state) {
      state.mobileNav = true;
    },
    'MENU_NAV_MOBILE/CLOSE_NAV': function(state) {
      state.mobileNav = false;
    },
  },
};

export default MenuNavMobile;
